import React, { useCallback, useEffect, useState } from 'react';
import PaymentsHeader from './PaymentsHeader';
import PaymentsListHeader from './PaymentsListHeader';
import PaymentsList from './PaymentsList';
import { useIsMobile, useT } from '@repo/common';
import { getMyPaymentHistory } from '../../../api/payment/payment.api';

const Payments = () => {
  const t = useT();
  const isMobile = useIsMobile();
  const [currentFilter, setCurrentFilter] = useState('ALL');
  const [pendingCount, setPendingCount] = useState(0);

  const fetchPendingCount = useCallback(async () => {
    try {
      const data = await getMyPaymentHistory(0, 1, 'PENDING_GROUP');
      setPendingCount(data.totalElements ?? 0);
    } catch (error) {
      console.error('pending 개수를 불러오지 못했습니다.', error);
    }
  }, []);

  useEffect(() => {
    if (isMobile) fetchPendingCount();
  }, [isMobile, fetchPendingCount]);

  return (
    <div className='flex flex-col tablet:min-w-[790px] tabletH:max-w-[868px] w-full tabletH:pb-[60px] items-start'>
      {isMobile && pendingCount > 0 && (
        <div className='w-full px-3 pb-3 typo-b12Strong text-text-secondary'>
          {pendingCount}
          {t(' payments need action', '건의 결제가 처리 대기 중입니다')}
        </div>
      )}

      <PaymentsHeader
        currentFilter={currentFilter}
        onFilterChange={setCurrentFilter}
        $isMobile={isMobile}
      />
      {!isMobile && (
        <>
          <PaymentsListHeader />
        </>
      )}
      <PaymentsList
        currentFilter={currentFilter}
        onDataChange={fetchPendingCount}
        $isMobile={isMobile}
      />
    </div>
  );
};

export default Payments;
